/* Melissa Cardinals SOP 1.2 controls, limited to three draft products. */
(() => {
  const products = new Set([
    'melissa-cardinals-cheer-cardinal-spirit-bow-tee',
    'melissa-cardinals-band-marching-pride-spirit-tee'
  ]);
  const path = location.pathname.split('/').filter(Boolean);
  if (path[0] !== 'products' || !products.has(path[1])) return;
  const css = `
    variant-picker[data-product-id="15483171406105"] [data-option-name="Color"] .variant-option__button-label__text,
    variant-picker[data-product-id="15483171438873"] [data-option-name="Color"] .variant-option__button-label__text,
    variant-picker[data-product-id="15483171504409"] [data-option-name="Color"] .variant-option__button-label__text
    {display:flex!important;flex-direction:column!important;align-items:center;justify-content:center;gap:3px;text-align:center;}
    variant-picker[data-product-id="15483171406105"] [data-option-name="Color"] .variant-option__button-label,
    variant-picker[data-product-id="15483171438873"] [data-option-name="Color"] .variant-option__button-label,
    variant-picker[data-product-id="15483171504409"] [data-option-name="Color"] .variant-option__button-label
    {min-height:62px;}
    [data-melissa-sop-maker]{font-size:12px;font-weight:600;line-height:1.25;display:block;white-space:normal;}
    [data-melissa-sop-color]{font-size:14px;font-weight:700;line-height:1.25;display:block;}
    variant-picker[data-product-id="15483171406105"] .variant-option__button-label:has(input:disabled),
    variant-picker[data-product-id="15483171438873"] .variant-option__button-label:has(input:disabled),
    variant-picker[data-product-id="15483171504409"] .variant-option__button-label:has(input:disabled)
    {position:relative;background:#e6e6e6!important;color:#606060!important;opacity:1!important;cursor:not-allowed;}
    variant-picker[data-product-id="15483171406105"] .variant-option__button-label:has(input:disabled)::after,
    variant-picker[data-product-id="15483171438873"] .variant-option__button-label:has(input:disabled)::after,
    variant-picker[data-product-id="15483171504409"] .variant-option__button-label:has(input:disabled)::after
    {content:"";position:absolute;inset:0;z-index:4;pointer-events:none;background:linear-gradient(154deg,transparent calc(50% - .8px),#888 50%,transparent calc(50% + .8px));}
    variant-picker[data-product-id="15483171406105"] .variant-option__button-label:has(input:disabled) .variant-option__strikethrough,
    variant-picker[data-product-id="15483171438873"] .variant-option__button-label:has(input:disabled) .variant-option__strikethrough,
    variant-picker[data-product-id="15483171504409"] .variant-option__button-label:has(input:disabled) .variant-option__strikethrough
    {display:none!important;}
    /* Generic custom radio labels can sit outside the standard variant picker. */
    .product-form__radio-label[data-melissa-sop-unavailable="true"],
    .variant-option__button-label[data-melissa-sop-unavailable="true"] {
      background:#e6e6e6!important;color:#606060!important;border-color:#bbb!important;
      opacity:1!important;cursor:not-allowed!important;position:relative!important;
    }
    /* Match every visible selector, including custom product-form radio labels. */
    label[data-melissa-sop-unavailable="true"] {
      position:relative!important;background:#e6e6e6!important;color:#606060!important;
      border-color:#bbb!important;opacity:1!important;cursor:not-allowed!important;
    }
    label[data-melissa-sop-unavailable="true"]::after {
      content:"";position:absolute;inset:0;z-index:6;pointer-events:none;
      background:linear-gradient(154deg,transparent calc(50% - .8px),#888 50%,transparent calc(50% + .8px));
    }
    label[data-melissa-sop-unavailable="true"] .variant-option__strikethrough,
    label[data-melissa-sop-unavailable="true"] .performance-unavailable-diagonal {display:none!important;}
    /* SOP 1.2: a single readable diagonal on each disabled selection.
       Hide any strike marks inherited from the theme's standard picker. */
    label[data-melissa-sop-unavailable="true"]::before,
    label[data-melissa-sop-unavailable="true"] .variant-option__strikethrough,
    label[data-melissa-sop-unavailable="true"] [class*="unavailable-diagonal"] {
      content:none!important;display:none!important;
    }
    label[data-melissa-sop-unavailable="true"]::after {
      content:""!important;display:block!important;position:absolute!important;
      inset:0!important;z-index:6!important;pointer-events:none!important;
      background:linear-gradient(154deg,transparent calc(50% - .8px),#888 50%,transparent calc(50% + .8px))!important;
    }
    label[data-melissa-sop-unavailable="true"] input {pointer-events:none!important;}

    /* Melissa SOP color strip v2: show five requested color choices;
       a disabled Silver swatch is never a Pepper product variant. */
    label[data-melissa-sop-pepper="true"] {display:none!important;}
    [data-melissa-sop-silver]{
      display:flex;min-height:62px;flex-direction:column;align-items:center;
      justify-content:center;text-align:center;padding:8px 10px;
      border:1px solid #bbb;border-radius:6px;position:relative;
      background:#e6e6e6!important;color:#606060!important;opacity:1;
      cursor:not-allowed;pointer-events:none;
    }
    [data-melissa-sop-silver]::after{
      content:"";position:absolute;inset:0;z-index:4;pointer-events:none;
      background:linear-gradient(154deg,transparent calc(50% - .8px),#888 50%,transparent calc(50% + .8px));
    }
    [data-melissa-sop-silver] [data-melissa-sop-maker]{font-size:12px;}
    [data-melissa-sop-silver] [data-melissa-sop-color]{font-size:14px;}
    [data-melissa-sop-color-value="White"] {order:1}
    [data-melissa-sop-color-value="Black"] {order:2}
    [data-melissa-sop-color-value="Red"] {order:3}
    [data-melissa-sop-color-value="Sport Grey"] {order:4}
    [data-melissa-sop-color-value="Silver"] {order:5}
    /* Suppress native duplicate marks on all genuinely disabled controls. */
    variant-picker[data-product-id="15483171438873"] .variant-option__button-label:has(input:disabled)::before,
    variant-picker[data-product-id="15483171504409"] .variant-option__button-label:has(input:disabled)::before {
      content:none!important;display:none!important;
    }
        @media(max-width:749px){[data-melissa-sop-maker]{font-size:11px;}}
  `;
  const style = document.createElement('style');
  style.id = 'melissa-sop-draft-controls';
  style.textContent = css;
  document.head.append(style);
  const isCheerBand = path[1] === 'melissa-cardinals-cheer-cardinal-spirit-bow-tee' ||
    path[1] === 'melissa-cardinals-band-marching-pride-spirit-tee';
  const isSoftball = path[1] === 'melissa-cardinals-softball-open-stitch-spirit-tee';
  const legacyAllowed = {
    'Gildan 5000': {colors:['Black','White','Sport Grey','Red'], sizes:['S','M','L','XL','2XL','3XL']},
    'Gildan 5000B Youth': {colors:['Black','White','Sport Grey','Red'], sizes:['Youth XS','Youth S','Youth M','Youth L','Youth XL']},
    'Rabbit Skins 3321 Toddler': {colors:['Black','White','Sport Grey'], sizes:['2T','4T','5/6T']},
    'Comfort Colors 1717': {colors:['Black','White','Red'], sizes:['S','M','L','XL','2XL','3XL']}
  };
  const cheerBandAllowed = {
    'Gildan Softstyle 64000': {colors:['Black','White','Sport Grey','Red'], sizes:['S','M','L','XL','2XL','3XL']},
    'Gildan Softstyle 64000B Youth': {colors:['Black','White','Sport Grey','Red'], sizes:['Youth XS','Youth S','Youth M','Youth L','Youth XL']},
    'Rabbit Skins 3321 Toddler': {colors:['Black','White','Heather'], sizes:['2T','4T','5/6T']},
    'Comfort Colors 1717': {colors:['Black','White','Red','Pepper','Grey'], sizes:['S','M','L','XL','2XL','3XL']},
    'Comfort Colors 9018 Youth': {colors:['White','Black','Crimson','Grey','Pepper'], sizes:['Youth XS','Youth S','Youth M','Youth L','Youth XL']}
  };
  const softballAllowed = {...legacyAllowed,
    'Comfort Colors 1717': {colors:['Black','White','Red','Pepper'], sizes:['S','M','L','XL','2XL','3XL']},
    'Comfort Colors 9018 Youth': {colors:['White','Black','Crimson','Grey','Pepper'], sizes:['Youth XS','Youth S','Youth M','Youth L','Youth XL']}
  };
  const allowed = isSoftball ? softballAllowed : (isCheerBand ? cheerBandAllowed : legacyAllowed);
  const colorsByGarment = Object.fromEntries(Object.entries(allowed).map(([name, entry]) => [name, entry.colors]));
  function selectedGarment() {
    const selected = [...document.querySelectorAll('input[type="radio"]:checked,button[aria-pressed="true"],button[aria-selected="true"]')];
    for (const control of selected) {
      const value = (control.value || control.closest('label')?.textContent || control.textContent || '').trim();
      if (colorsByGarment[value]) return value;
    }
    const picker = document.querySelector('variant-picker');
    const native = picker?.querySelector('fieldset[data-option-name="Garment"] input:checked');
    return native?.value && colorsByGarment[native.value] ? native.value : '';
  }
  function syncDisabledColors() {
    const garment = selectedGarment();
    const allowed = colorsByGarment[garment];
    if (!allowed) return;
    const colorNames = ['Black','White','Sport Grey','Red','Heather','Pepper','Grey','Crimson'];
    const labels = document.querySelectorAll(
      'label.product-form__radio-label, label.variant-option__button-label, label:has(input[name="properties[Shirt Style & Color]"])'
    );
    for (const label of labels) {
      const input = label.querySelector('input[type="radio"]') ||
        (label.htmlFor ? document.getElementById(label.htmlFor) : null);
      if (!input) continue;
      const field = input.closest('fieldset');
      const inColorGroup = field?.dataset.optionName === 'Color' ||
        /color|colour|style/i.test(field?.querySelector('legend')?.textContent || '') ||
        /color|colour|style/i.test(input.name || '') ||
        label.classList.contains('product-form__radio-label');
      if (!inColorGroup) continue;
      const raw = (input.value || label.textContent || '').trim();
      const color = colorNames.find(c => raw === c ||
        raw.endsWith(' ' + c) || raw.endsWith('/' + c) ||
        (label.textContent || '').trim().endsWith(c));
      if (!color) continue;
      const unavailable = !allowed.includes(color);
      label.dataset.melissaSopUnavailable = String(unavailable);
      label.setAttribute('aria-disabled',String(unavailable));
      if (unavailable) {
        input.disabled = true;
        input.setAttribute('aria-disabled','true');
        input.dataset.melissaSopDisabled='true';
      } else if (input.dataset.melissaSopDisabled === 'true') {
        input.disabled = false;
        input.removeAttribute('aria-disabled');
        delete input.dataset.melissaSopDisabled;
      }
    }
  }
  function apply() {
    syncDisabledColors();
    const picker = document.querySelector('variant-picker[data-product-id="15483171406105"],variant-picker[data-product-id="15483171438873"],variant-picker[data-product-id="15483171504409"]');
    if (!picker) return;
    const garmentField = picker.querySelector('fieldset[data-option-name="Garment"]');
    const garment = garmentField?.querySelector('input:checked')?.value ||
      garmentField?.querySelector('input[data-current-checked="true"]')?.value ||
      garmentField?.querySelector('input')?.value || 'Select garment';
    const colorField = picker.querySelector('fieldset[data-option-name="Color"]');
    if (!colorField) return;
    // Use the real Shopify variant map. Unsupported combinations remain visible, but disabled.
    // These four exact garment/color/size combinations are grounded in the 231 Shopify variants.

    const valid = allowed[garment];
    const chosenColor = colorField.querySelector('input:checked')?.value || '';
    const sizeField = picker.querySelector('fieldset[data-option-name="Size"]');
    const setSopDisabled = (input, unavailable) => {
      if (unavailable) {
        input.dataset.melissaSopDisabled = 'true';
        input.disabled = true;
        input.setAttribute('aria-disabled','true');
      } else if (input.dataset.melissaSopDisabled === 'true') {
        delete input.dataset.melissaSopDisabled;
        input.disabled = false;
        input.removeAttribute('aria-disabled');
      }
      const label = input.closest('label') || (input.id && document.querySelector('label[for="' + CSS.escape(input.id) + '"]'));
      if (label) {
        const state = input.dataset.melissaSopDisabled === 'true';
        if (state) label.hidden = false;
        if (state) label.dataset.melissaSopUnavailable = 'true';
        else delete label.dataset.melissaSopUnavailable;
        label.setAttribute('aria-disabled',String(state));
      }
    };
    if (valid) {
      colorField.querySelectorAll('input[type="radio"]').forEach(input =>
        setSopDisabled(input,!valid.colors.includes(input.value)));
      sizeField?.querySelectorAll('input[type="radio"]').forEach(input =>
        setSopDisabled(input,!valid.sizes.includes(input.value) || (!!chosenColor && !valid.colors.includes(chosenColor))));
      // A second product-form control sometimes renders above Shopify's native picker.
      // Restrict modifications to its color choices; retain all legitimate inventory options.
      document.querySelectorAll('input[type="radio"][name="properties[Shirt Style & Color]"]').forEach(input => {
        const value = input.value.trim();
        const color = valid.colors.concat(['Pepper','Sport Grey']).find(c => value === c || value.endsWith(' ' + c) || value.endsWith('/' + c));
        if (color) setSopDisabled(input,!valid.colors.includes(color));
      });
    }
    for (const label of colorField.querySelectorAll('label.variant-option__button-label')) {
      const color = label.querySelector('input')?.value;
      const wrapper = label.querySelector('.variant-option__button-label__text');
      if (!wrapper || !color) continue;
      const maker = wrapper.querySelector('[data-melissa-sop-maker]');
      const shade = wrapper.querySelector('[data-melissa-sop-color]');
      label.dataset.melissaSopColorValue = color;
      if (!(isCheerBand || isSoftball) && color === 'Pepper') {
        label.dataset.melissaSopPepper = 'true';
        label.hidden = true;
      } else {
        delete label.dataset.melissaSopPepper;
        label.hidden = false;
      }
      const displayColor = color === 'Sport Grey' ? 'Gray' : color;
      if (maker && shade) {
        if (maker.textContent !== garment) maker.textContent = garment;
        if (shade.textContent !== displayColor) shade.textContent = displayColor;
      } else {
        const first = document.createElement('span');
        first.dataset.melissaSopMaker = '';
        first.textContent = garment;
        const second = document.createElement('span');
        second.dataset.melissaSopColor = '';
        second.textContent = displayColor;
        wrapper.replaceChildren(first, second);
      }
    }
    // Never leave a hidden or disabled color selected after switching garment.
    const checkedColor = colorField.querySelector('input[type="radio"]:checked');
    if (checkedColor && (checkedColor.disabled || (!(isCheerBand || isSoftball) && checkedColor.value === 'Pepper'))) {
      const alternate = [...colorField.querySelectorAll('input[type="radio"]')]
        .find(input => input.value === 'White' && !input.disabled)
        || [...colorField.querySelectorAll('input[type="radio"]')].find(input => !input.disabled);
      if (alternate && alternate !== checkedColor) {
        requestAnimationFrame(() => {
          if (!alternate.isConnected || alternate.disabled || alternate.checked) return;
          alternate.click();
        });
      }
    }
    // Only show Silver as disabled until real Silver variants and correct images exist.
    if (!(isCheerBand || isSoftball) && !colorField.querySelector('[data-melissa-sop-silver]')) {
      const silver = document.createElement('span');
      silver.className = 'variant-option__button-label';
      silver.dataset.melissaSopSilver = '';
      silver.dataset.melissaSopColorValue = 'Silver';
      silver.dataset.melissaSopUnavailable = 'true';
      silver.setAttribute('aria-disabled','true');
      silver.setAttribute('aria-label',garment + ', Silver — unavailable');
      silver.innerHTML = '<span class="variant-option__button-label__text"><span data-melissa-sop-maker></span><span data-melissa-sop-color>Silver</span></span>';
      colorField.append(silver);
    }
    if (isCheerBand || isSoftball) colorField.querySelector('[data-melissa-sop-silver]')?.remove();
    const silver = colorField.querySelector('[data-melissa-sop-silver]');
    if(silver) {
      silver.querySelector('[data-melissa-sop-maker]').textContent=garment;
      silver.setAttribute('aria-label',garment + ', Silver — unavailable');
    }
  }
  // Stop clicks at capture phase on unavailable option labels, even with custom handlers.
  document.addEventListener('click', e => {
    if (!e.target.closest) return;
    const label = e.target.closest('label[data-melissa-sop-unavailable="true"]');
    if (label) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);
    let queued = false;
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {queued = false; apply();});
  };
  document.addEventListener('change', e => {
    if (e.target.closest?.('variant-picker')) schedule();
  });
  const observer = new MutationObserver(schedule);
  observer.observe(document.documentElement,{childList:true,subtree:true,attributes:true,attributeFilter:['checked','data-current-checked']});
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',schedule,{once:true});
  else schedule();
})();